import API from '../../APIs/API';

interface PrequalRecommendationData {
    email: string;
    customerId?: string;
    primaryRecommendation: string;
    primaryScript?: string;
    fallbackRecommendation: string;
    fallbackScript?: string;
    fallbackTriggers?: string;
    ineligibleForOriginal?: boolean;
    prequalParameters: any; // All the prequal form data
    intentFocus?: string;
    householdIncome?: number;
    age?: number;
}

export async function savePrequalRecommendations(data: PrequalRecommendationData) {
    console.log('savePrequalRecommendations called with:', {
        email: data.email,
        primary: data.primaryRecommendation,
        fallback: data.fallbackRecommendation,
    });

    try {
        const result = await API.Call<any>('v2/recommendation/agent-portal-prequal', 'POST', data);

        console.log('Saved Zeus prequal recommendations', {
            email: data.email,
            primaryRecommendation: data.primaryRecommendation,
            fallbackRecommendation: data.fallbackRecommendation,
            result,
        });
    } catch (error) {
        console.error('Failed to save Zeus prequal recommendations', error);
        // Don't throw - we don't want to fail the main flow if saving fails
    }
}
